import React from 'react';
import { isVoidField } from '@formily/core';
import { connect, mapProps } from '@formily/react';
import { useFormLayout } from '@/form/cn-form-layout';
import { CnFormItem as UiCnFormItem, } from '@/components/cn-form-item';
const useFormItemLayout = (props) => {
    const layout = useFormLayout();
    return {
        ...props,
        labelAlign: (props.labelAlign ?? layout.labelAlign),
        labelWidth: (props.labelWidth ?? layout.labelWidth),
        labelCol: (props.labelCol ?? layout.labelCol),
        wrapperCol: (props.wrapperCol ?? layout.wrapperCol),
        asterisk: props.asterisk,
        labelTextAlign: props.labelTextAlign ?? layout.labelTextAlign,
        wrapperAlign: props.wrapperAlign ?? layout.wrapperAlign,
    };
};
// 适配
export const CnFormItem = connect((props) => {
    const { children, ...others } = props;
    const triggerRef = React.useRef();
    const cnFormItemProps = {
        triggerRef,
        ...useFormItemLayout(others),
    };
    let displayChildren;
    if (React.isValidElement(children)) {
        cnFormItemProps.triggerName = children?.type?.displayName;
        if (props?.fullWidth) {
            // fullWidth 撑开
            displayChildren = React.cloneElement(children, {
                ref: triggerRef,
                insideForm: true,
                formLabel: props.title,
                style: {
                    width: '100%',
                },
            });
        }
        else {
            displayChildren = React.cloneElement(children, {
                ref: triggerRef,
                insideForm: true,
                formLabel: props.title,
            });
        }
    }
    else {
        displayChildren = children;
    }
    return (React.createElement(UiCnFormItem, { ...cnFormItemProps }, displayChildren));
}, mapProps((props, field) => {
    if (isVoidField(field)) {
        return {
            readOnly: field.readOnly,
            label: field.title || props.label,
            asterisk: props.asterisk,
            extra: props.extra || field.description,
        };
    }
    if (!field)
        return props;
    const takeFeedbackStatus = () => {
        if (field.validating)
            return 'pending';
        return field.decoratorProps.feedbackStatus || field.validateStatus;
    };
    // 获取错误信息
    const takeMessage = () => {
        const split = (messages) => {
            return messages.reduce((buf, text) => {
                if (!text)
                    return buf;
                return buf.concat(text);
            }, []);
        };
        if (field.validating)
            return;
        if (props.feedbackText)
            return props.feedbackText;
        if (field.selfErrors.length) {
            if (props.requiredMessage) {
                return [props.requiredMessage];
            }
            else {
                return split(field.selfErrors);
            }
        }
        if (field.selfWarnings.length)
            return split(field.selfWarnings);
        if (field.selfSuccesses.length)
            return split(field.selfSuccesses);
    };
    // 获取是否有 required mark
    const takeAsterisk = () => {
        if (field.required && field.pattern !== 'readPretty') {
            return true;
        }
        if ('asterisk' in props) {
            return props.asterisk;
        }
        return false;
    };
    return {
        title: props.label || field.title,
        validateState: takeFeedbackStatus(),
        errors: takeMessage(),
        asterisk: takeAsterisk(),
        extra: props.extra || field.description,
        readOnly: field.readOnly,
        disabled: field.disabled,
    };
}));
